import { useState, useEffect, useCallback } from 'react';
import { fetchApi } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

export function useConnections() {
  const { user } = useAuth();
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!user) { setLoading(false); return; }
    try {
      const data = await fetchApi('/api/connections');
      setConnections(data.connections || []);
    } catch (err) {
      console.error('Failed to load connections:', err);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { load(); }, [load]);

  const requestToPitch = useCallback(async (companyId) => {
    const data = await fetchApi('/api/connections/request', {
      method: 'POST',
      body: JSON.stringify({ company_id: companyId }),
    });
    await load();
    return data.connection;
  }, [load]);

  const respond = useCallback(async (connectionId, status) => {
    const data = await fetchApi(`/api/connections/${connectionId}/respond`, {
      method: 'PUT',
      body: JSON.stringify({ status }),
    });
    await load();
    return data.connection;
  }, [load]);

  const pending = connections.filter(c => c.status === 'pending');
  const approved = connections.filter(c => c.status === 'approved');
  const declined = connections.filter(c => c.status === 'declined');

  return { connections, pending, approved, declined, loading, requestToPitch, respond, refresh: load };
}
